import { belowBreakpointOrEqual, fadeColor, fromThemeCreator, getColor, Icon, keyframes, lightenColor, styled } from 'imaginarity-react-ui';
import { jello } from 'layout/parts/PartsSC';
import { QuizTheme } from './QuizMain';

const selectFromTheme = fromThemeCreator<QuizTheme>("quizTheme");

const slideDashTop = keyframes`
    from { transform: translateX(-50%); }
    to { transform: translateX(0%); }
`;
const slideDashRight = keyframes`   
    from { transform: translateY(-50%); }
    to { transform: translateY(0%); }
`;
const slideDashBottom = keyframes`
    from { transform: translateX(0%); }
    to { transform: translateX(-50%); }
`;
const slideDashLeft = keyframes`   
    from { transform: translateY(0%); }
    to { transform: translateY(-50%); }
`;

const pulse0 = keyframes`
    from {transform: scale(1);animation-timing-function: ease-out;opacity: 0.2;}
    5% {transform: scale(0.91);animation-timing-function: ease-in;opacity: 0.5;}
    8% {transform: scale(0.98);animation-timing-function: ease-out;opacity: 1;}
    16% {transform: scale(0.87);animation-timing-function: ease-in;opacity: 0.5;}
    22% {transform: scale(1);animation-timing-function: ease-out;opacity: 0.2;}
`;
const pulse1 = keyframes`
    0%,50%,100% {opacity: 1; stroke: #f1f1f1;}
    25%,75% {opacity: 0;stroke: rgb(149, 0, 20);}
`;
const pulse2 = keyframes`
    0%,50%,100% {opacity: 1; fill: rgb(49, 54, 57);}
    25%,75% {opacity: 0;fill: #ffffff;}
`;

const pulse = keyframes`
        from {
            transform: scale(1);
            transform-origin: center center;
            animation-timing-function: ease-out;
            opacity: 0.2;
        }
        2% {
            transform: scale(0.91);
            animation-timing-function: ease-in;
            opacity: 0.5;
        }
        3% {
            transform: scale(0.98);
            animation-timing-function: ease-out;
            opacity: 1;
        }
        6% {
            transform: scale(0.87);
            animation-timing-function: ease-in;
            opacity: 0.5;
        }
        9% {
            transform: scale(1);
            animation-timing-function: ease-out;
            opacity: 0.2;
        }
`;
const fadeInRight = keyframes`
        from { opacity: 0; }
        to { opacity: 1; }
`;
const slideBtmInOut = keyframes`
        0% , 100%{
                transform: translateY(100px) scaleY(1.0) scaleX(1.0);
                opacity: 0;
        }
        20%,80% {
                transform: translateY(-150px) scaleY(1.0) scaleX(1.0);
                opacity: 1;
        }
`;
const slideBtmInOutWarning = keyframes`
        0% , 100%{
                transform: translateY(100px) scaleY(1.0) scaleX(1.0);
                opacity: 0;
        }
        20%,80% {
                transform: translateY(-150px) scaleY(1.0) scaleX(1.0);
                opacity: 1;
        }
        67%,69%,71%,73%,75% {
                transform: translateY(-150px) scaleY(1.0) scaleX(1.0);
                color: #FFFFFF;
                opacity: 1;
        }
        68%,70%,72%,74% {
                transform: translateY(0) scaleY(0.8) scaleX(1.2);
                color: rgb(149, 0, 20);            
                opacity: 1;
        }
`;
export class QuizSC {
        public static Container = styled.div`
        width: 100%;
        max-width: 535px;
        min-width:320px;
        margin: auto;
    `;
        public static QuizBackground = styled.div`
        width: 100%;
        height: 100%;
        background: ${props => getColor(props, props.theme.colors.mainBackground)};
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 800'%3E%3Cdefs%3E%3CradialGradient id='a' cx='400' cy='400' r='50%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(255,255,255,0.9)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,1)'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='400' cy='400' r='70%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(204,204,204,0.4)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,0.4)'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='800'/%3E%3Cg fill-opacity='.8'%3E%3Cpath fill='url(%23b)' d='M998.7 439.2c1.7-26.5 1.7-52.7 0.1-78.5L401 399.9c0 0 0-0.1 0-0.1l587.6-116.9c-5.1-25.9-11.9-51.2-20.3-75.8L400.9 399.7c0 0 0-0.1 0-0.1l537.3-265c-11.6-23.5-24.8-46.2-39.3-67.9L400.8 399.5c0 0 0-0.1-0.1-0.1l450.4-395c-17.3-19.7-35.8-38.2-55.5-55.5l-395 450.4c0 0-0.1 0-0.1-0.1L733.4-99c-21.7-14.5-44.4-27.6-68-39.3l-265 537.4c0 0-0.1 0-0.1 0l192.6-567.4c-24.6-8.3-49.9-15.1-75.8-20.2L400.2 399c0 0-0.1 0-0.1 0l39.2-597.7c-26.5-1.7-52.7-1.7-78.5-0.1L399.9 399c0 0-0.1 0-0.1 0L282.9-188.6c-25.9 5.1-51.2 11.9-75.8 20.3l192.6 567.4c0 0-0.1 0-0.1 0l-265-537.3c-23.5 11.6-46.2 24.8-67.9 39.3l332.8 498.1c0 0-0.1 0-0.1 0.1L4.4-51.1C-15.3-33.9-33.8-15.3-51.1 4.4l450.4 395c0 0 0 0.1-0.1 0.1L-99 66.6c-14.5 21.7-27.6 44.4-39.3 68l537.4 265c0 0 0 0.1 0 0.1l-567.4-192.6c-8.3 24.6-15.1 49.9-20.2 75.8L399 399.8c0 0 0 0.1 0 0.1l-597.7-39.2c-1.7 26.5-1.7 52.7-0.1 78.5L399 400.1c0 0 0 0.1 0 0.1l-587.6 116.9c5.1 25.9 11.9 51.2 20.3 75.8l567.4-192.6c0 0 0 0.1 0 0.1l-537.3 265c11.6 23.5 24.8 46.2 39.3 67.9l498.1-332.8c0 0 0 0.1 0.1 0.1l-450.4 395c17.3 19.7 35.8 38.2 55.5 55.5l395-450.4c0 0 0.1 0 0.1 0.1L66.6 899c21.7 14.5 44.4 27.6 68 39.3l265-537.4c0 0 0.1 0 0.1 0L207.1 968.3c24.6 8.3 49.9 15.1 75.8 20.2L399.8 401c0 0 0.1 0 0.1 0l-39.2 597.7c26.5 1.7 52.7 1.7 78.5 0.1L400.1 401c0 0 0.1 0 0.1 0l116.9 587.6c25.9-5.1 51.2-11.9 75.8-20.3L400.3 400.9c0 0 0.1 0 0.1 0l265 537.3c23.5-11.6 46.2-24.8 67.9-39.3L400.5 400.8c0 0 0.1 0 0.1-0.1l395 450.4c19.7-17.3 38.2-35.8 55.5-55.5l-450.4-395c0 0 0-0.1 0.1-0.1L899 733.4c14.5-21.7 27.6-44.4 39.3-68l-537.4-265c0 0 0-0.1 0-0.1l567.4 192.6c8.3-24.6 15.1-49.9 20.2-75.8L401 400.2c0 0 0-0.1 0-0.1L998.7 439.2z'/%3E%3C/g%3E%3C/svg%3E"), linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 5%, rgba(255,255,255,0) 95%, rgba(255,255,255,1) 100%);
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        padding: ${p => belowBreakpointOrEqual(p, "tablet") ? 0 : "calc((100vh - " + p.theme.content.height + "px - 40px) / 2)"}; 
`;

        public static ContainerBackgroundBlur = styled.div<{ isPpeQuiz?: boolean }>`
        position: relative;
        width: ${p => belowBreakpointOrEqual(p, "tablet") ? "100%" : "calc(100% - 40px)"};
        max-width: 535px;
        min-width:320px;
        height: ${p => p.theme.content.height - (belowBreakpointOrEqual(p, "tablet") ? -40 : 40)}px;
        margin: auto;
        background: rgba(255,255,255,0.5);        
        box-shadow: ${p => belowBreakpointOrEqual(p, "tablet") ? "none" : "0 1px 4px " + getColor(p, p.theme.colors.middleLightGrey) + ", 0 0 100px " + getColor(p, p.theme.colors.mainBackground) + " inset"}; 
        top: calc((100vh - ${p => p.theme.content.height}px - 0px) / 2);
        transition: 0.2s all ease-in-out;
        &:before{
                backdrop-filter: blur(${p => p.isPpeQuiz ? 0 : 5}px);
                position: absolute;
                width: 100%;
                height: 100%;
                content: "";
                transform: translateX(${p => p.isPpeQuiz ? -50 : 0}%);
        }
`;
        public static ContainerGrid = styled.div<{ imageAvailable: boolean, decreaseView?: boolean }>`
                position: ${p => belowBreakpointOrEqual(p, "tablet") ? "fixed" : "absolute"};
                left: 50%;
                transform: translateX(-50%);

                width: ${p => p.theme.content.width}px;
                max-width: 535px;
                min-width: 320px;
                height: ${p => belowBreakpointOrEqual(p, "tablet") ? "unset" : p.theme.content.height - 25 + "px"};
                top: ${p => belowBreakpointOrEqual(p, "tablet") ? p.theme.headerHeight : 0}px;
                bottom: ${p => belowBreakpointOrEqual(p, "tablet") ? "50px" : "unset"};
                margin: auto;
                overflow: hidden;
                display: grid;
                display: -ms-grid; 
                grid-template-columns: 1fr;
                -ms-grid-columns: 1fr;
                user-select: none;
                grid-template-rows: 50px ${p => p.decreaseView ? " 0px 0px " : " minmax(40px, max-content) min-content "} ${p => p.imageAvailable ? belowBreakpointOrEqual(p, "tablet") ? p.decreaseView ? "0px" : "150px" : p.decreaseView ? "0px" : "150px" : "0px"} 1fr ${p => belowBreakpointOrEqual(p, "mobile") ? "50px" : "100px"};
                -ms-grid-rows:  50px ${p => p.decreaseView ? " 0px 0px " : " minmax(40px, max-content) min-content "} ${p => p.imageAvailable ? belowBreakpointOrEqual(p, "tablet") ? p.decreaseView ? "0px" : "150px" : p.decreaseView ? "0px" : "150px" : "0px"} 1fr ${p => belowBreakpointOrEqual(p, "mobile") ? "50px" : "100px"};
                padding: ${p => belowBreakpointOrEqual(p, "tablet") ? "0 20px 0 5px" : "20px"};
`;
        public static ContainerGridInvite = styled.div`
        position: relative;
        width: ${p => belowBreakpointOrEqual(p, "tablet") ? "100%" : "calc(100% - 40px)"};
        max-width: 535px;
        min-width:320px;
        height: 100%;
        margin: auto;
        overflow: hidden;
        overflow-y: auto;
        display: grid;
        display: -ms-grid;
        grid-template-columns: 1fr;
        -ms-grid-columns: 1fr;
        grid-template-rows: ${p => belowBreakpointOrEqual(p, "tablet") ? "0px min-content min-content min-content 1fr 50px" : "40px 40px min-content min-content 1fr 100px"};
        -ms-grid-rows: ${p => belowBreakpointOrEqual(p, "tablet") ? "0px min-content min-content min-content 1fr 50px" : "40px 40px min-content min-content 1fr 100px"};
        background: rgba(255,255,255,0.5);
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        padding: ${p => belowBreakpointOrEqual(p, "tablet") ? "0 5px" : "20px"};
        box-shadow: ${p => belowBreakpointOrEqual(p, "tablet") ? "none" : "0 1px 4px " + getColor(p, p.theme.colors.middleLightGrey) + ", 0 0 100px " + getColor(p, p.theme.colors.mainBackground) + " inset"};
`;

        public static Header = styled.div`
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 1;
        grid-row: 1;
        position: relative;
`;
        public static HeaderInfo = styled.div`
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 1;
        grid-row: 1;
        font-size: 1.5rem;
        font-weight: bolder;
        color: ${props => getColor(props, props.theme.colors.mainForeground)};
        line-height: 50px;
`;
        public static Title = styled.div<{ rightAnswer?: boolean }>`
        color: ${props => getColor(props, props.rightAnswer === undefined ? props.theme.colors.mainForeground : props.rightAnswer ? props.theme.colors.accentGreen : props.theme.colors.accentRed)};
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 2;
        grid-row: 2;
        font-size: 1.1rem;
        font-weight: bolder;
        border-bottom: 1px solid ${props => getColor(props, props.theme.colors.middleLightGrey)};
        line-height: 30px;
        padding-top: 10px 0 5px 0;
`;
        public static Description = styled.div`
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 3;
        grid-row: 3;
        //border-left: 3px solid ${props => getColor(props, props.theme.colors.accent)};
        padding: 10px 0;
        font-size: 1rem;
        //background: rgba(255,255,0,0.1);
    `;
        public static Image = styled.div`
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 4;
        grid-row: 4;
        position: relative;
        min-height: 95px;
    *:focus {
        outline: 0;
    }
    .slider-control-left{
        cursor: pointer;
        transition: all 0.2s ease-out;
        svg{
            stroke: rgba(255,255,255,0.5);
        &:hover{
            stroke: ${p => getColor(p, p.theme.colors.accent)};
        }
        }
    }
    .slider-control-left-mobile{
        cursor: pointer;
        transition: all 0.2s ease-out;
        margin-left: -15px;
        margin-top: 0px;
        svg{
            stroke: rgba(255,255,255,0.5);
        &:hover{
            stroke: ${p => getColor(p, p.theme.colors.accent)};
        }
        }
    }
    .slider-control-right{
        cursor: pointer;
        transition: all 0.2s ease-out;
        
        svg{
            stroke: rgba(255,255,255,0.5);
        &:hover{
            stroke: ${p => getColor(p, p.theme.colors.accent)};
        }
        }
    }
    .slider-control-right-mobile{
        cursor: pointer;
        transition: all 0.2s ease-out;
        margin-right: -15px;
        margin-top: -10px;
        svg{
            stroke: rgba(255,255,255,0.5);
        &:hover{
            stroke: ${p => getColor(p, p.theme.colors.accent)};
        }
        }
    }
    .bullets{
        display: none;
    }
`;
        public static ImageMAIP = styled.div`
        grid-column: 1;
        grid-row-start: 4;
        grid-row-end: 6;
        //background: rgba(0,0,255,0.1);
        position: relative;
        overflow-y: auto;
`;
        public static Functions = styled.div`
        -ms-grid-column: 1;
        grid-column: 1; 
        -ms-grid-row: 5;
        grid-row: 5;
        overflow-y: auto;
        overflow-x: hidden;
        padding-top: 10px;
        min-height: 150px;
`;
        public static Footer = styled.div`
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 6;
        grid-row: 6;
        text-align: center;
        position: relative;
        //background: rgba(255,0,0,0.1);
`;
        public static FooterHint = styled.div`
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 6;
        grid-row: 6;
        text-align: center;
        position: relative;
        pointer-events: none;
        `;
        public static Card = styled.div`
        margin: 10px 0px 30px 0px;
        box-shadow: ${props => getColor(props, props.theme.appStart.boxShadow)};
    `;

        public static ItemCard = styled.div`
        margin: 0px;
        border: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 93)};
        box-shadow: 0 6px 8px -6px ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@darkerGrey")), 10)};
        width: 100%;
        height: 100%;
        display: grid;
        display: -ms-grid;
        grid-template-columns: 1fr;
        -ms-grid-columns: 1fr;
        grid-template-rows: min-content 60px 24px 150px 40px 40px;
        -ms-grid-rows: min-content 60px 24px 150px 40px 40px;
    `;
        public static ICimage = styled.div`
            -ms-grid-column: 1;
            grid-column: 1; 
            -ms-grid-row: 1;
            grid-row: 1;
            margin-bottom: -10px;
            cursor: pointer;
    `;
        public static ICtitle = styled.div`
            -ms-grid-column: 1;
            grid-column: 1; 
            -ms-grid-row: 2;
            grid-row: 2;
            font-weight: bolder;
            font-size: 1.1rem;
            line-height: 60px;
            padding: 0 10px;
            background: ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@veryLightGrey")), 95)};
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;  
            cursor: pointer;
            &:hover{
                color: ${props => fadeColor(props, selectFromTheme(props, t => t.quizAccent, t => getColor(props, "@accent")), 100)};
            }
    `;
        public static ICinfo = styled.div`
            -ms-grid-column: 1;
            grid-column: 1; 
            -ms-grid-row: 3;
            grid-row: 3;
            margin: 0 10px;
            font-size: 0.7rem;
            line-height: 24px;
            border-bottom: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@veryLightGrey")), 93)};
            color: ${props => fadeColor(props, selectFromTheme(props, t => t.color, t => getColor(props, "@lightGrey")), 70)};
            text-transform: uppercase;
            display: grid;
            display: -ms-grid;
            grid-template-columns: 1fr max-content;
            -ms-grid-columns: 1fr max-content;
            grid-template-rows: 24px;
            -ms-grid-rows: 24px;
    `;
        public static ICcontent = styled.div`
            -ms-grid-column: 1;
            grid-column: 1; 
            -ms-grid-row: 4;
            grid-row: 4;
            margin: 10px;
            padding: 0px 5px 0px 0;
            font-size: 0.9rem;
            height: 130px;
            overflow-y: auto;
    `;
        public static ICicons = styled.div`
            -ms-grid-column: 1;
            grid-column: 1; 
            -ms-grid-row: 5;
            grid-row: 5;
            display: grid;
            display: -ms-grid;
            grid-template-columns: 40px 40px 40px 40px 40px 1fr;
            -ms-grid-columns: 40px 40px 40px 40px 40px 1fr;
            grid-template-rows: 24px;
            -ms-grid-rows: 24px;
            text-align: center;
            border-top: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@veryLightGrey")), 85)};
    `;

        public static ICfooter = styled.div`
            -ms-grid-column: 1;
            grid-column: 1; 
            -ms-grid-row: 6;
            grid-row: 6;
            background: ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@veryLightGrey")), 93)};
            border-top: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@veryLightGrey")), 85)};
    `;
        public static ICiconsCount = styled.div`
            position: absolute;
            width: 30px;
            text-align: right;
            right: 5px;
            top: -1px;
            font-size: 0.65rem;
            color: ${props => getColor(props, props.theme.colors.lightGrey)};
            pointer-events: none;
    `;
        public static ICiconsContainer = styled.div`
            position: relative;
            height: 40px;
            //padding-top:7px;
    `;
        public static ICbookmarkContainer = styled.div`
                height: 40px;
    `;
        public static PlayerNameContainer = styled.div`
                position: relative;
                width: 100%;
                background: transparent;
                height: ${p => belowBreakpointOrEqual(p, "mobile") ? 60 : 120}px;
                margin-bottom: ${p => belowBreakpointOrEqual(p, "mobile") ? -30 : -40}px;
                :first-child{
                        margin-top: 0px;
                }
                :last-child{
                        margin-bottom: ${p => belowBreakpointOrEqual(p, "mobile") ? 10 : 40}px;
                }
    `;
        public static InviteFirstName = styled.div<{ position: "left" | "right" }>`
                position: absolute;
                text-align: ${p => p.position};
                top: ${p => belowBreakpointOrEqual(p, "mobile") ? 10 : 30}px;                
                left: ${p => p.position === "left" ? belowBreakpointOrEqual(p, "mobile") ? "40px" : "80px" : "unset"};
                right: ${p => p.position === "right" ? belowBreakpointOrEqual(p, "mobile") ? "40px" : "80px" : "unset"};
                transform: translate(0%, 0%);
                text-transform: uppercase;
                font-size: ${p => belowBreakpointOrEqual(p, "mobile") ? 30 : 45}px;
                font-weight: 700;
                transform-origin: ${p => p.position} center;
                transform: scale(${p => belowBreakpointOrEqual(p, "tablet") ? 0.5 : 1}); 
                color: ${props => belowBreakpointOrEqual(props, "mobile") ? getColor(props, props.theme.colors.mainBackground) : getColor(props, props.theme.colors.veryLightGrey)};
                text-shadow: 1px 1px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 2px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 3px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 4px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 5px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 6px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 7px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 8px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 9px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 10px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 18px 6px rgba(16, 16, 16, 0.4),
                1px 22px 10px rgba(16, 16, 16, 0.2),
                1px 25px 35px rgba(16, 16, 16, 0.2),
                -1px -10px 60px rgba(16, 16, 16, 0.5),
                1px 30px 60px rgba(16, 16, 16, 0.5);
    `;
        public static InviteLastName = styled.div<{ position: "left" | "right" }>`
                position: absolute;
                text-align: ${p => p.position};
                bottom: ${p => belowBreakpointOrEqual(p, "mobile") ? 15 : 30}px;       
                left: ${p => p.position === "left" ? belowBreakpointOrEqual(p, "mobile") ? "30px" : "60px" : "unset"};
                right: ${p => p.position === "right" ? belowBreakpointOrEqual(p, "mobile") ? "30px" : "60px" : "unset"};
                text-transform: uppercase;
                font-size: ${p => belowBreakpointOrEqual(p, "mobile") ? 20 : 36}px;    
                font-weight: 700;
                transform-origin: ${p => p.position} center;
                transform: scale(${p => belowBreakpointOrEqual(p, "tablet") ? 0.5 : 1}); 
                color: ${props => belowBreakpointOrEqual(props, "mobile") ? getColor(props, props.theme.colors.mainBackground) : getColor(props, props.theme.colors.veryLightGrey)};
                text-shadow: 1px 1px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 2px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 3px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 4px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 5px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 6px 1px ${props => getColor(props, props.theme.colors.lightGrey)},
                1px 18px 6px rgba(16, 16, 16, 0.4),
                1px 22px 10px rgba(16, 16, 16, 0.2),
                1px 25px 35px rgba(16, 16, 16, 0.2),
                1px 30px 60px rgba(16, 16, 16, 0.4);
`;
        public static InviteUserAvatar = styled.div<{ position: "left" | "right" }>`
                box-shadow: ${p => p.position === "left" ? 4 : -4}px 6px 8px -6px ${props => getColor(props, props.theme.colors.mainForeground)};
                padding: 3px;
                position: absolute;
                ${p => p.position}: 5px;
                top: 0px;
                width: ${p => belowBreakpointOrEqual(p, "mobile") ? 50 : 100}px;
                height: ${p => belowBreakpointOrEqual(p, "mobile") ? 50 : 100}px;
                border-radius: ${p => belowBreakpointOrEqual(p, "mobile") ? 25 : 50}px;
`;
        public static InviteUserVersus = styled.div<{ position: "left" | "right", delay: number }>`
                position: absolute;
                top: ${p => belowBreakpointOrEqual(p, "mobile") ? -10 : 0}px;
                left: ${p => p.position === "left" ? belowBreakpointOrEqual(p, "mobile") ? "25%" : "60%" : "unset"};
                right: ${p => p.position === "right" ? belowBreakpointOrEqual(p, "mobile") ? "25%" : "60%" : "unset"};
                animation: ${pulse} ${p => 5 + p.delay * 4}s linear ${p => p.delay}s infinite both ;
                font-size: ${p => belowBreakpointOrEqual(p, "mobile") ? 20 : 50}px;
                font-weight: 900;
                color: ${props => fadeColor(props, getColor(props, props.theme.colors.accent), 90)};
                -webkit-text-stroke-width: ${p => belowBreakpointOrEqual(p, "mobile") ? 0 : 0.4}px;
                -webkit-text-stroke-color: ${props => belowBreakpointOrEqual(props, "mobile") ? "unset" : getColor(props, props.theme.colors.mainBackground)};
                text-shadow:
                -12px -16px ${props => fadeColor(props, getColor(props, props.theme.colors.accent), belowBreakpointOrEqual(props, "mobile") ? 0 : 40)}, 
                8px 6px ${props => fadeColor(props, getColor(props, props.theme.colors.accent), belowBreakpointOrEqual(props, "mobile") ? 0 : 30)}, 
                -12px 14px ${props => fadeColor(props, getColor(props, props.theme.colors.accent), belowBreakpointOrEqual(props, "mobile") ? 0 : 20)}, 
                6px -10px ${props => fadeColor(props, getColor(props, props.theme.colors.accent), belowBreakpointOrEqual(props, "mobile") ? 0 : 10)};
`;
        public static PlayButton = styled.svg<{ disabled?: boolean, bgColor?: string, borderColor?: string, lightMode: boolean }>`
                text-align: center;
                margin: 0 auto;
                transition: 0.2s all ease-in-out;
                transform-origin: center center;
                //transform: scale(${props => belowBreakpointOrEqual(props, "tablet") ? 0.5 : 1});
                cursor: pointer;
                user-select: none;
                opacity: ${p => p.disabled ? 0.2 : 1};
                filter: grayscale(${p => p.disabled ? 1 : 0});
                .QuizPlayButton {
                        fill: ${props => getColor(props, props.bgColor ?? props.theme.colors.accent)};
                        stroke: ${props => getColor(props, props.borderColor ?? props.theme.colors.mainForeground)};
                        
                }
                .QuizPlayButtonText{
                                fill: ${props => props.lightMode ? getColor(props, props.theme.colors.mainForeground) : getColor(props, props.theme.colors.mainBackground)};
                }
                .QuizPlayButtonBg{
                                fill: ${props => getColor(props, props.theme.colors.middleLightGrey)};
                }
                &:hover{
                        transform: scale(0.95);
                }
        `;

        public static TopImage = styled.div`
                position: absolute;
                top: 5px;
                left:40px;
        `;

        public static FooterInfo = styled.div<{ warning: boolean, duration: number, delay: number }>`
                font-size: ${p => belowBreakpointOrEqual(p, "tablet") ? 35 : 80}px;
                font-weight: bold;
                text-transform: uppercase;
                transform-origin: center center;
                line-height: ${p => belowBreakpointOrEqual(p, "tablet") ? 50 : 100}px;
                color: ${props => getColor(props, props.theme.colors.mainBackground)};
                animation:  ${p => p.warning ? slideBtmInOutWarning : slideBtmInOut} ${p => p.duration}s cubic-bezier(0.250, 0.460, 0.450, 0.940) ${p => p.delay}s both;
                text-shadow: 1px 3px 0 ${props => getColor(props, props.theme.colors.lightGrey)}, 1px ${p => belowBreakpointOrEqual(p, "tablet") ? 8 : 13}px 5px ${props => getColor(props, props.theme.colors.middleLightGrey)}, 0px 0px ${p => belowBreakpointOrEqual(p, "tablet") ? 20 : 40}px ${props => getColor(props, props.theme.colors.mainForeground)};
        `;

        public static ImageGridContainer = styled.div<{ imageUri?: string, height: number }>`
                position: absolute;
                left:0;
                top: 0;
                width: 100%;
                height: ${p => p.height}px;
                background-image: url('${props => props.imageUri ?? "none"}');
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                filter: opacity(0.1) grayscale(1);
        `;

        public static Ribbon = styled.div<{ color: "correct" | "wrong" | "info" }>`
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 1;
        overflow: hidden;
        width: 75px;
        height: 75px;
        text-align: right;
        transform-origin: top left;
        transform: scale(0.85);
        span {
            font-size: 10px;
            font-weight: bold;
            color: #FFF;
            text-transform: uppercase;
            text-align: center;
            line-height: 20px;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            width: 100px;
            display: block;
            background:  linear-gradient(${p => p.color === "correct" ? lightenColor(p, p.theme.colors.accentGreen, 80) : p.color === "wrong" ? lightenColor(p, p.theme.colors.accentRed, 80) : lightenColor(p, p.theme.colors.darkGrey, 80)}, ${p => p.color === "correct" ? p.theme.colors.accentGreen : p.color === "wrong" ? p.theme.colors.accentRed : p.theme.colors.darkGrey});
            box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
            position: absolute;
            top: 19px;
            left: -21px;
            z-index: 2;
        }
`;

        public static MultipleChoiceIcon = styled(Icon) <{ selected: boolean }>`
        position: absolute;
        right: 1px;
        bottom: 3px;
        animation:  ${fadeInRight} 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        svg{
                stroke: ${p => p.selected ? getColor(p, p.theme.colors.accent) : getColor(p, p.theme.colors.middleLightGrey)};
        }
`;
        public static CoolaterateIcon = styled(Icon) <{ full?: boolean }>`
                position: absolute;
                right: ${p => p.full ? 3 : -2}px;
                top: 50%;
                transform: translateY(-50%);
                animation:  ${fadeInRight} 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
                svg{
                        stroke: ${p => getColor(p, p.theme.colors.middleLightGrey)};
                }
`;
        public static SortText = styled.div<{ full?: boolean, withBg?: boolean, isDragging?: boolean }>`
        position: absolute;
        top: ${p => p.withBg ? "unset" : "50%"};
        bottom: ${p => p.withBg ? 0 : "unset"};
        left: 0;
        width: 100%;
        background: ${p => p.withBg ? fadeColor(p, getColor(p, p.theme.colors.middleLightGrey), 75) : "inherit"};
        color: ${p => p.withBg ? getColor(p, p.theme.colors.accentBlack) : p.isDragging ? getColor(p, p.theme.colors.mainBackground) : "inherit"};
        padding: 0 ${p => p.full ? 30 : 20}px 0 ${p => p.full ? 5 : 15}px;
        transform: translateY(${p => p.withBg ? 0 : "-50%"});
        font-weight: bold;
        text-align: center;
        overflow: hidden;
        word-wrap: normal;
        -ms-overflow-style: none;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -moz-box-orient: vertical;
        -ms-box-orient: vertical;
        box-orient: vertical;
        -webkit-line-clamp: ${p => p.withBg ? 1 : 4};
        -moz-line-clamp: ${p => p.withBg ? 1 : 4};
        -ms-line-clamp: ${p => p.withBg ? 1 : 4};
        line-clamp: ${p => p.withBg ? 1 : 4};
`;
        public static FourPicCell = styled.div<{ correct?: boolean, empty?: boolean }>`
                font-size: 24px;
                line-height: 40px;
                border: 1px solid ${p => p.correct === undefined ? p.empty ? getColor(p, p.theme.colors.middleLightGrey) : getColor(p, p.theme.colors.accentBlack) : p.correct ? getColor(p, p.theme.colors.accentGreen) : getColor(p, p.theme.colors.accentRed)};
                color: ${p => p.correct === undefined ? p.empty ? getColor(p, p.theme.colors.mainForeground) : getColor(p, p.theme.colors.mainBackground) : p.correct ? getColor(p, p.theme.colors.accentGreen) : getColor(p, p.theme.colors.accentRed)};
                text-align: center;
                min-width: 30px;
                min-height: 40px;
                cursor: ${p => p.empty ? "default" : "pointer"};
                background: ${p => p.correct === undefined ? p.empty ? getColor(p, p.theme.colors.mainBackground) : getColor(p, p.theme.colors.darkGrey) : p.correct ? fadeColor(p, getColor(p, p.theme.colors.accentGreen), 10) : fadeColor(p, getColor(p, p.theme.colors.accentRed), 10)};
                transition: all 0.2s ease-out;
                border-bottom-color: ${p => p.empty ? getColor(p, p.theme.colors.accent) : "inherit"};
                box-shadow: ${p => p.empty ? "none" : "0 6px 8px -6px" + getColor(p, p.theme.colors.mainForeground)};
                transform-origin: center center;
                &:hover{
                        background:${p => p.empty ? getColor(p, p.theme.colors.mainBackground) : getColor(p, p.theme.colors.accentRed)};
                        border: 1px solid ${p => p.empty ? getColor(p, p.theme.colors.middleLightGrey) : getColor(p, p.theme.colors.mainForeground)};
                        border-bottom-color: ${p => p.empty ? getColor(p, p.theme.colors.accent) : "inherit"};
                        transform: scale(${p => p.empty ? 1 : 0.95});
                }
`;
        public static FourPicLetters = styled.div<{ selected: boolean }>`
                font-size: 24px;
                line-height: 40px;
                border: 1px solid ${p => p.selected ? getColor(p, p.theme.colors.lightGrey) : getColor(p, p.theme.colors.middleLightGrey)};
                color: ${p => p.selected ? getColor(p, p.theme.colors.mainForeground) : getColor(p, p.theme.colors.middleLightGrey)};
                text-align: center;
                min-width: 30px;
                min-height: 40px;
                cursor: ${p => p.selected ? "pointer" : "default"};
                background:${p => getColor(p, p.theme.colors.mainBackground)};
                transition: all 0.2s ease-out;
                &:hover{
                        background:${p => p.selected ? getColor(p, p.theme.colors.darkGrey) : getColor(p, p.theme.colors.mainBackground)};
                        color: ${p => p.selected ? getColor(p, p.theme.colors.mainBackground) : getColor(p, p.theme.colors.middleLightGrey)};
                        border: 1px solid ${p => p.selected ? getColor(p, p.theme.colors.mainForeground) : getColor(p, p.theme.colors.middleLightGrey)};
                }
`;

        public static MCQcontainer = styled.div < { selected: boolean, fullWidth: boolean }> `
                position: relative;
                border: 1px solid  ${p => p.selected ? getColor(p, p.theme.colors.middleLightGrey) : getColor(p, p.theme.colors.middleLightGrey)};
                background: ${p => p.selected ? getColor(p, p.theme.colors.veryLightGrey) : getColor(p, p.theme.colors.mainBackground)}; 
                color:${p => p.selected ? getColor(p, p.theme.colors.accentBlack) : getColor(p, p.theme.colors.mainForeground)};
                height: 80px;
                margin: 0px 1px -4px 1px;
                margin-bottom: ${p => (belowBreakpointOrEqual(p, "tablet") || p.fullWidth) ? "2px" : "-4px"};
                padding: 0;
                width: ${p => (belowBreakpointOrEqual(p, "tablet") || p.fullWidth) ? "96%" : "calc(50% - 2px)"};
                display: inline-block;
                transition: 0.2s all ease-out;
                cursor: pointer;
                font-size: 0.95rem;
                text-align: center;
                &:hover {
                        background:  ${p => p.selected ? getColor(p, p.theme.colors.middleLightGrey) : getColor(p, p.theme.colors.mainForeground)};
                        color:${p => p.selected ? getColor(p, p.theme.colors.mainForeground) : getColor(p, p.theme.colors.mainBackground)};
                        svg{
                                stroke: ${p => p.selected ? getColor(p, p.theme.colors.accent) : getColor(p, p.theme.colors.accentBlack)};
                        }
                }
`;
        public static EstiQuesTop = styled.div`
                width: 100%;
                line-height: 40px;
                font-size:1rem;
                font-weight: bolder;
                padding: 0 12px;
`;
        public static EstiQuesMin = styled.div`
                width: 10%;
                color: ${p => p.theme.colors.lightGrey};
                text-align: left;
                display: inline-block;
`;
        public static EstiQuesMax = styled.div`
                width: 10%;
                color: ${p => p.theme.colors.lightGrey};
                text-align: right;
                display: inline-block;
`;
        public static EstiQuesValue = styled.div<{ showSolution: boolean }>`
                width: 80%;
                text-align: center;
                display: inline-block;
                color: ${p => p.showSolution ? p.theme.colors.lightGrey : "inherit"};
`;
        public static EstiQuesValueCorrect = styled.div`
                width: 100%;
                margin-top: 20px;
                text-align: center;
`;

        public static EstiQuesSliderContainer = styled.div<{ notHooverable: boolean }>`
                cursor: ${p => p.notHooverable ? "default" : "pointer"};
                width: calc(100% - 30px);
                position: relative;
                margin-top: 0px;
                padding-top: 0px;
                margin-bottom: 0px;
                margin-left: 15px;
                margin-right: 15px;
`;
        public static EQSliderBar = styled.div`
    background-color: ${p => getColor(p, p.theme.colors.veryLightGrey)};
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    height: 24px;
    width: 100%;
`;
        public static EQSlider = styled.div<{ show?: boolean, correct: boolean }>`
                margin-top: -6px;
                width: 5%;
                border: 1px solid ${p => p.show ? p.correct ? getColor(p, p.theme.colors.accentGreen) : getColor(p, p.theme.colors.accentRed) : lightenColor(p, getColor(p, p.theme.colors.lightGrey), 70)};
                background-color:  ${p => p.show ? p.correct ? fadeColor(p, getColor(p, p.theme.colors.accentGreen), 25) : fadeColor(p, getColor(p, p.theme.colors.accentRed), 25) : fadeColor(p, getColor(p, p.theme.colors.darkGrey), 50)};
                height: 36px;
                z-index: 4;
                position: absolute;
                opacity: 1 !important;
                box-shadow: 0 6px 8px -6px ${p => getColor(p, p.theme.colors.mainForeground)};
                transition: 0.2s background-color ease-in-out;
                &:hover{
                        background-color:  ${p => p.show ? p.correct ? fadeColor(p, getColor(p, p.theme.colors.accentGreen), 25) : fadeColor(p, getColor(p, p.theme.colors.accentRed), 25) : fadeColor(p, getColor(p, p.theme.colors.darkGrey), 80)};
                }
`;
        public static EQSliderCorrectLeft = styled.div`
        margin-top: 0px;
        background-color: ${p => fadeColor(p, getColor(p, p.theme.colors.accentGreen), 20)};
        height: 22px;
        z-index: 3;
        position: absolute;
        opacity: 1 !important;
`;
        public static EQSliderCorrectRight = styled.div`
        margin-top: 0px;
        background-color: ${p => fadeColor(p, getColor(p, p.theme.colors.accentGreen), 20)};
        height: 22px;
        z-index: 3;
        position: absolute;
        opacity: 1 !important;
        border-left: 3px solid ${p => getColor(p, p.theme.colors.accentGreen)};
`;
        public static SQdraggableContainer = styled.div<{ isDragging: boolean }>`
    background-color: ${p => p.isDragging ? getColor(p, p.theme.colors.accent) : getColor(p, p.theme.colors.mainBackground)};
    width: calc(100% - 1px);
    position: relative;
    border: 1px solid ${p => p.isDragging ? getColor(p, p.theme.colors.mainForeground) : getColor(p, p.theme.colors.middleLightGrey)};
    margin-bottom:5px;
    color: ${p => p.isDragging ? getColor(p, p.theme.colors.mainBackground) : getColor(p, p.theme.colors.mainForeground)};
    height: 80px;
    transition: 0.2s background-color ease-in-out;
    box-shadow: ${p => p.isDragging ? "0 16px 8px -12px " + getColor(p, p.theme.colors.mainForeground) : "none"};
    &:hover{
        background-color: ${p => getColor(p, p.theme.colors.darkGrey)};
        color: ${p => getColor(p, p.theme.colors.mainBackground)};
    }
`;
        public static CPQRibbonLeft = styled.div`
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 1;
    overflow: hidden;
    width: 75px;
    height: 75px;
    text-align: right;
    span {
        font-size: 10px;
        font-weight: bold;
        color:  ${p => getColor(p, p.theme.colors.mainBackground)};
        text-transform: uppercase;
        text-align: center;
        line-height: 20px;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        width: 100px;
        display: block;
        background:  ${p => "linear-gradient(" + lightenColor(p, getColor(p, p.theme.colors.darkGrey), 150) + "," + getColor(p, p.theme.colors.darkGrey) + ")"};
        box-shadow: 0 3px 10px -5px ${p => getColor(p, p.theme.colors.lightGrey)};
        position: absolute;
        top: 5px;
        left: -35px;
        z-index: 2;
    }
`;

        public static CPQRibbonRight = styled.div`
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 100;
    overflow: hidden;
    width: 75px;
    height: 75px;
    text-align: right;
    span {
        font-size: 10px;
        font-weight: bold;
        color:  ${p => getColor(p, p.theme.colors.mainBackground)};
        text-transform: uppercase;
        text-align: center;
        line-height: 20px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        width: 100px;
        display: block;
        background:  ${p => "linear-gradient(" + lightenColor(p, getColor(p, p.theme.colors.darkGrey), 150) + "," + getColor(p, p.theme.colors.darkGrey) + ")"};
        box-shadow: 0 3px 10px -5px ${p => getColor(p, p.theme.colors.lightGrey)};
        position: absolute;
        top: 5px;
        right: -35px;
    }    
`;
        public static CPQContainerLeft = styled.div`
    position: relative;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    height: 80px;
    margin: 5px 0;
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
`;
        public static CPQIconRight = styled.div`
    position: absolute;
    top: 50%;
    right: -15px;
    width: 30px;
    height: 30px;
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    transform: translateY(-50%);
    z-index: 10;
    border-radius: 15px;
    background:${p => getColor(p, p.theme.colors.mainBackground)};
    svg{
        stroke: ${p => getColor(p, p.theme.colors.middleLightGrey)};
    }
`;

        public static CPQContainerRight = styled.div <{ isDragging: boolean }>`
        position: relative;
        top: 0px;
        left: 0px;
        bottom: 0px;
        right: 0px;
        height: 80px;
        margin: 5px 0;
        border: ${p => p.isDragging ? 0 : 1}px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
        text-align: center;
        background-color: ${p => p.isDragging ? getColor(p, p.theme.colors.accent) : getColor(p, p.theme.colors.mainBackground)};
        color: ${p => p.isDragging ? getColor(p, p.theme.colors.mainBackground) + "!important" : getColor(p, p.theme.colors.mainForeground)};
        transition: 0.2s all ease-in-out;
        box-shadow: ${p => p.isDragging ? "0 16px 8px -12px " + getColor(p, p.theme.colors.darkGrey) : "none"};
        &:hover{
                svg{
                        stroke: ${p => getColor(p, p.theme.colors.accent)};
                }
        }
`;
        public static FunctionsHeader = styled.div`
        font-size: 1.1rem;
        font-weight: bolder;
        margin: 10px 0;
`;
        public static ResultContainer = styled.div`
        //position: ${p => belowBreakpointOrEqual(p, "tablet") ? "absolute" : "absolute"};
        width: ${p => p.theme.content.width}px;
        max-width: 535px;
        min-width:320px;
        //top: 50%;
        //left: 50%;
        //transform: translate(-50%, -50%);
        margin: auto;
        text-align: center;
        padding-top: 40px;
        background-color: ${props => getColor(props, props.theme.colors.mainBackground)};
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 800'%3E%3Cdefs%3E%3CradialGradient id='a' cx='400' cy='400' r='50%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(255,255,255,0.9)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,1)'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='400' cy='400' r='70%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(204,204,204,0.4)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,0.4)'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='800'/%3E%3Cg fill-opacity='.8'%3E%3Cpath fill='url(%23b)' d='M998.7 439.2c1.7-26.5 1.7-52.7 0.1-78.5L401 399.9c0 0 0-0.1 0-0.1l587.6-116.9c-5.1-25.9-11.9-51.2-20.3-75.8L400.9 399.7c0 0 0-0.1 0-0.1l537.3-265c-11.6-23.5-24.8-46.2-39.3-67.9L400.8 399.5c0 0 0-0.1-0.1-0.1l450.4-395c-17.3-19.7-35.8-38.2-55.5-55.5l-395 450.4c0 0-0.1 0-0.1-0.1L733.4-99c-21.7-14.5-44.4-27.6-68-39.3l-265 537.4c0 0-0.1 0-0.1 0l192.6-567.4c-24.6-8.3-49.9-15.1-75.8-20.2L400.2 399c0 0-0.1 0-0.1 0l39.2-597.7c-26.5-1.7-52.7-1.7-78.5-0.1L399.9 399c0 0-0.1 0-0.1 0L282.9-188.6c-25.9 5.1-51.2 11.9-75.8 20.3l192.6 567.4c0 0-0.1 0-0.1 0l-265-537.3c-23.5 11.6-46.2 24.8-67.9 39.3l332.8 498.1c0 0-0.1 0-0.1 0.1L4.4-51.1C-15.3-33.9-33.8-15.3-51.1 4.4l450.4 395c0 0 0 0.1-0.1 0.1L-99 66.6c-14.5 21.7-27.6 44.4-39.3 68l537.4 265c0 0 0 0.1 0 0.1l-567.4-192.6c-8.3 24.6-15.1 49.9-20.2 75.8L399 399.8c0 0 0 0.1 0 0.1l-597.7-39.2c-1.7 26.5-1.7 52.7-0.1 78.5L399 400.1c0 0 0 0.1 0 0.1l-587.6 116.9c5.1 25.9 11.9 51.2 20.3 75.8l567.4-192.6c0 0 0 0.1 0 0.1l-537.3 265c11.6 23.5 24.8 46.2 39.3 67.9l498.1-332.8c0 0 0 0.1 0.1 0.1l-450.4 395c17.3 19.7 35.8 38.2 55.5 55.5l395-450.4c0 0 0.1 0 0.1 0.1L66.6 899c21.7 14.5 44.4 27.6 68 39.3l265-537.4c0 0 0.1 0 0.1 0L207.1 968.3c24.6 8.3 49.9 15.1 75.8 20.2L399.8 401c0 0 0.1 0 0.1 0l-39.2 597.7c26.5 1.7 52.7 1.7 78.5 0.1L400.1 401c0 0 0.1 0 0.1 0l116.9 587.6c25.9-5.1 51.2-11.9 75.8-20.3L400.3 400.9c0 0 0.1 0 0.1 0l265 537.3c23.5-11.6 46.2-24.8 67.9-39.3L400.5 400.8c0 0 0.1 0 0.1-0.1l395 450.4c19.7-17.3 38.2-35.8 55.5-55.5l-450.4-395c0 0 0-0.1 0.1-0.1L899 733.4c14.5-21.7 27.6-44.4 39.3-68l-537.4-265c0 0 0-0.1 0-0.1l567.4 192.6c8.3-24.6 15.1-49.9 20.2-75.8L401 400.2c0 0 0-0.1 0-0.1L998.7 439.2z'/%3E%3C/g%3E%3C/svg%3E"), linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 5%, rgba(255,255,255,0) 95%, rgba(255,255,255,1) 100%);
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        height: 90vh;
        box-shadow: 0 6px 8px -6px #000;
`;
        public static ResultContainerMobile = styled.div`
                position: fixed;
                width: ${p => p.theme.content.width}px;
                top: 50px;
                left: 0;
                right: 0;
                bottom: 90px;
                text-align: center;
                overflow-y: auto;
`;
        public static ResultHeader = styled.div`
        transform-origin: center center;
        transform: scale(${p => belowBreakpointOrEqual(p, "mobile") ? 0.8 : 1});
        margin-top: ${p => belowBreakpointOrEqual(p, "mobile") ? "40px" : 0};
                .box {
                        display: flex;
                }

                .box .inner {
                        width: 100%;
                        height: 120px;
                        line-height: 120px;
                        font-size: 1.4rem;
                        font-weight: bold;
                        white-space: nowrap;
                        overflow: hidden;
                        box-shadow: 0 10px 10px -8px black;
                }

                .box .innerSmall {
                        width: 100%;
                        height: 120px;
                        line-height: 120px;
                        font-size: 1.2rem;
                        font-weight: bold;
                        white-space: nowrap;
                        overflow: hidden;
                        box-shadow: 0 10px 10px -8px black;
                }

                .box .inner:first-child {
                        background-color: ${p => fadeColor(p, getColor(p, p.theme.colors.veryLightGrey), 80)};
                        color: ${p => getColor(p, p.theme.colors.mainForeground)};
                        transform-origin: right;
                        transform: perspective(100px) rotateY(-8deg);
                }

                .box .inner:last-child {
                        background-color: ${p => fadeColor(p, getColor(p, p.theme.colors.mainBackground), 80)};
                        color: ${p => getColor(p, p.theme.colors.mainForeground)};
                        transform-origin: left;
                        transform: perspective(100px) rotateY(8deg);
                        border-left: 1px solid ${p => getColor(p, p.theme.colors.lightGrey)};
                }

                .box .inner span {
                        position: absolute;
                        animation: marquee 5s linear infinite;
                }

                .box .inner:first-child span {
                        animation-delay: 2.5s;
                        left: -100%;
                        opacity: (0.5);
                }

                @keyframes marquee {
                        0% {left: 100%; opacity: (0.5);}
                        50% {left: 0%; opacity: (1);}
                        100% {left: -100%; opacity: (0.5);}
                }

                .box .bottom {
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        font-size: 1rem;
                        font-weight: bolder;
                        white-space: nowrap;
                        overflow: hidden;
                        box-shadow: 0 4px 6px -4px ${p => getColor(p, p.theme.colors.darkGrey)};
                        margin: 5px auto;
                }
                .box .bottom:first-child {
                        background-color: ${p => fadeColor(p, getColor(p, p.theme.colors.veryLightGrey), 70)};
                        color: ${p => fadeColor(p, getColor(p, p.theme.colors.mainForeground), 80)};
                        text-align: right;
                        padding-right: 10px;
                        width: ${p => belowBreakpointOrEqual(p, "tablet") ? 40 : 25}%;
                        margin-left: ${p => belowBreakpointOrEqual(p, "tablet") ? 10 : 25}%;
                        border-top-left-radius: 20px;
                        border-bottom-left-radius: 20px;
                }

                .box .bottom:last-child {
                        background-color: ${p => fadeColor(p, getColor(p, p.theme.colors.mainBackground), 70)};
                        color: ${p => fadeColor(p, getColor(p, p.theme.colors.mainForeground), 80)};
                        border-left: 1px solid ${p => getColor(p, p.theme.colors.lightGrey)};
                        text-align: left;
                        padding-left: 10px;
                        width: ${p => belowBreakpointOrEqual(p, "tablet") ? 40 : 25}%;
                        margin-right: ${p => belowBreakpointOrEqual(p, "tablet") ? 10 : 25}%;
                        border-top-right-radius: 20px;
                        border-bottom-right-radius: 20px;
                }
`;
        public static ResultPercentage = styled.div`
                transform-origin: center center;
                margin-top: ${p => belowBreakpointOrEqual(p, "mobile") ? -147 : -170}px;
                text-transform: uppercase;
                font-size: 1.5rem;
                position: relative;
                height: 120px;
                transform: scale(${p => belowBreakpointOrEqual(p, "mobile") ? 0.55 : 1});

`;

        public static Stats = styled.div`
                padding-top: ${p => belowBreakpointOrEqual(p, "mobile") ? 0 : "110px"};
        `;

        public static ResultVersusContainer = styled.div<{ pos?: "one" | "two" | "three" }>`
                width: 95%;
                height: 70px;
                background: ${p => p.pos === "one" ? "rgba(246, 213, 0, 0.3)" : p.pos === "two" ? "rgba(150, 150, 150, 0.3)" : p.pos === "three" ? "rgba(173, 59, 54, 0.3)" : "transparent"};
                position: relative;
                border-radius: 35px;
                top: ${p => belowBreakpointOrEqual(p, "mobile") ? 10 : 90}px;
                left: 2.5%;
                margin-bottom: ${p => belowBreakpointOrEqual(p, "mobile") ? 10 : 50}px;
                border: 5px solid ${p => p.pos === "one" ? "rgba(246, 213, 0, 1)" : p.pos === "two" ? "rgba(150, 150, 150, 1)" : p.pos === "three" ? "rgba(173, 59, 54, 1)" : getColor(p, p.theme.colors.middleLightGrey)};
                padding: 0 10px;
`;
        public static QuizVersusPlayerPlaceContainer = styled.div<{ pos?: "one" | "two" | "three", first: boolean, position: "left" | "right" }>`
                position: absolute;
                top: -5px;
                ${p => p.position}: -5px;
                width: 70px;
                height: 70px;
                border-radius: 35px;
                line-height: 60px;
                text-align: center;
                background: ${p => p.pos === "one" ?
                        "conic-gradient(#edc800, #e3b600, #f3cf00, #ffe800, #ffe900, #ffeb00, #ffe000, #ebc500, #e0b100, #f1cc00, #fcdc00, #ffe500, #fad900, #eec200, #e7b900, #f7d300, #ffe800, #ffe300, #f5d100, #e6b900, #e3b600, #f4d000, #ffe400, #ebc600, #e3b600, #f6d500, #ffe900, #ffe90a, #edc800) content-box, linear-gradient(#f6d600, #f6d600) padding-box, radial-gradient(rgba(120, 120, 120, 0.9), rgba(120, 120, 120, 0) 70%) 50% bottom/80% 0.46875em no-repeat border-box" :
                        p.pos === "two" ? "conic-gradient(#d7d7d7, #c3c3c3, #cccccc, #c6c6c6, #d3d3d3, #d8d8d8, #d5d5d5, #d8d8d8, #d3d3d3, #c5c5c5, #c0c0c0, #bfbfbf, #d0d0d0, #d9d9d9, #d1d1d1, #c5c5c5, #c8c8c8, #d7d7d7, #d5d5d5, #cdcdcd, #c4c4c4, #d9d9d9, #cecece, #c5c5c5, #c5c5c5, #cdcdcd, #d8d8d8, #d9d9d9, #d7d7d7) content-box, linear-gradient(#d4d4d4, #d4d4d4) padding-box, radial-gradient(rgba(120, 120, 120, 0.9), rgba(120, 120, 120, 0) 70%) 50% bottom/80% 0.46875em no-repeat border-box" :
                                p.pos === "three" ? "conic-gradient(#d95641, #b14439, #b2453a, #d25645, #d56847, #d05441, #b85137, #b2453a, #c34f40, #df4647, #a94338, #c94943, #c85442, #a4413c, #d9543a, #d1564e, #ab4338, #bb4a3c, #dc5843, #b94839, #aa4237, #c24e42, #ce523f, #ab4338, #dd5944, #ca4d33, #ab4338, #cb503e, #d95641) content-box, linear-gradient(#ad3b36, #ad3b36) padding-box, radial-gradient(rgba(120, 120, 120, 0.9), rgba(120, 120, 120, 0) 70%) 50% bottom/80% 0.46875em no-repeat border-box" :
                                        getColor(p, p.theme.colors.mainBackground)};
                color: ${p => p.pos ? getColor(p, p.theme.colors.accentBlack) : getColor(p, p.theme.colors.mainForeground)};
                border: 5px solid ${p => p.pos === "one" ? "rgba(246, 213, 0, 1)" : p.pos === "two" ? "rgba(150, 150, 150, 1)" : p.pos === "three" ? "rgba(173, 59, 54, 1)" : getColor(p, p.theme.colors.middleLightGrey)};
                animation: ${p => p.first ? jello : "none"} 0.9s 5 both;

`;
        public static QuizVersusPlayerPlace = styled.div`
                display: inline-block;
                line-height: 50px;
                font-size: 1.4rem;
                font-weight: bolder;
`;

        public static InviteInfo1 = styled.div<{ position: "left" | "right" }>`
                position: absolute;
                bottom: 15px;
                line-height: 20px;
                ${p => p.position}: 70px;
                font-size: 0.8rem;
                color: ${p => getColor(p, p.theme.colors.mainForeground)};
`;
        public static InviteInfo2 = styled.div<{ position: "left" | "right" }>`
                position: absolute;
                bottom: 0px;
                line-height: 20px;
                ${p => p.position}: 63px;
                font-size: 0.8rem;
                color: ${p => getColor(p, p.theme.colors.mainForeground)};
`;
        public static QSHighScoreTable = styled.div<{ darkMode: boolean }>`
                width: 100%;
                margin-bottom: 20px;
                filter: invert(${p => p.darkMode ? 0.85 : 0});
                color: ${props => props.darkMode ? getColor(props, props.theme.colors.accentBlack) : getColor(props, props.theme.colors.darkerGrey)} !important;

                .QSDiagram {
                        height: 350px;
                }
`;
        public static StatsHL = styled.div<{ noBorder?: boolean }>`
                font-weight: bolder;
                border-bottom:  ${p => p.noBorder ? "none" : "1px solid " + getColor(p, p.theme.colors.middleLightGrey)};
                padding-bottom:3px;
                margin-bottom:5px;
`;
        public static StatsContainer = styled.div<{ height: string }>`
                min-height: 40px;
                padding: 15px;
                max-height: ${p => p.height};
                overflow-y : auto;
`;
        public static DiagramOuterContainer = styled.div`
                position: relative;
                width: 100%;
`;
        public static DiagramContainer = styled.div`
                height: 280px;
`;
        public static LegendTop = styled.div`
                position: absolute;
                width: fit-content;
                top: 0;
                right: 0;
                text-align: right;
`;
        public static LegendBottom = styled.div`
                position: absolute;
                width: fit-content;
                top: 280px;
                right: 0;
                text-align: right;
`;


        public static Informations = styled.div`
                border: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
`;
        public static Statistics = styled.div`
                border: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
    
`;
        public static UnfinishedGames = styled.div`
                border: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
`;
        public static Start = styled.div`
                border: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
                margin-bottom: 10px;
`;
        public static Comments = styled.div`
                border: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
`;
        public static Ratings = styled.div`
                border: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
                margin-top: 10px;
`;

        public static ItemHeadline = styled.div`
                border-bottom: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
                background: ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@veryLightGrey")), 93)};
                color: ${props => lightenColor(props, selectFromTheme(props, t => t.color, t => getColor(props, "@veryLightGrey")), 98)};
                font-size: 1rem;
                font-weight: bolder;
                height: 40px;
                line-height: 40px;
                padding-left: 10px;
`;
        public static DetailImageContainer = styled.div`

`;
        public static ImageContainer = styled.div`

`;
        public static InfoDate = styled.div`
                width: 100%;
                height: 40px;
                line-height: 40px;
                padding-left: 10px;
                border-bottom: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
                margin-top: -5px;
                font-size: 0.85rem;
`;
        public static InfoGroup = styled.div`
                float: right;
`;
        public static InfoHeadline = styled.div`
                font-size: 1rem;
                font-weight: bolder;
                padding: 10px 10px 0px 10px;
`;
        public static InfoDescription = styled.div`
                padding: 0px 10px 10px 10px;
                font-size: 0.85rem;
                min-height: 30px;
                max-height: 141px;
                overflow-y: auto;
                border-bottom: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@middleLightGrey")), 85)};
`;
        public static InfoFooter = styled.div`
            background: ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@veryLightGrey")), 93)};
            border-top: 1px solid ${props => lightenColor(props, selectFromTheme(props, t => t.backgroundColor, t => getColor(props, "@veryLightGrey")), 85)};
   
                height: 40px;
                display: grid;
                display: -ms-grid;
                grid-template-columns: 40px 40px 40px 40px 1fr;
                -ms-grid-columns: 40px 40px 40px 40px 1fr;
                grid-template-rows: 40px;
                -ms-grid-rows: 40px;
                text-align: center;
`;

        public static QuizButtonSingle = styled.div`
                display: inline-block;
                margin: 0 10px;
    
`;
        public static QuizButtonMulti = styled.div`
                display: inline-block;
`;
        public static FooterUsers = styled.div`
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                max-width: calc(50% - 50px);
        `;
        public static FooterUsersImage = styled.div<{ didAnswer: boolean }>`
                filter: grayscale(${p => p.didAnswer ? 0 : 1}) opacity(${p => p.didAnswer ? 1 : 0.3});
                float: right;
        `;

        public static QuizBackgroundMobile = styled.div`
                width: 100%;
                height: 100%;
                background-color: ${props => getColor(props, props.theme.colors.mainBackground)};
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 800'%3E%3Cdefs%3E%3CradialGradient id='a' cx='400' cy='400' r='50%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(255,255,255,0.9)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,1)'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='400' cy='400' r='70%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(204,204,204,0.4)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,0.4)'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='800'/%3E%3Cg fill-opacity='.8'%3E%3Cpath fill='url(%23b)' d='M998.7 439.2c1.7-26.5 1.7-52.7 0.1-78.5L401 399.9c0 0 0-0.1 0-0.1l587.6-116.9c-5.1-25.9-11.9-51.2-20.3-75.8L400.9 399.7c0 0 0-0.1 0-0.1l537.3-265c-11.6-23.5-24.8-46.2-39.3-67.9L400.8 399.5c0 0 0-0.1-0.1-0.1l450.4-395c-17.3-19.7-35.8-38.2-55.5-55.5l-395 450.4c0 0-0.1 0-0.1-0.1L733.4-99c-21.7-14.5-44.4-27.6-68-39.3l-265 537.4c0 0-0.1 0-0.1 0l192.6-567.4c-24.6-8.3-49.9-15.1-75.8-20.2L400.2 399c0 0-0.1 0-0.1 0l39.2-597.7c-26.5-1.7-52.7-1.7-78.5-0.1L399.9 399c0 0-0.1 0-0.1 0L282.9-188.6c-25.9 5.1-51.2 11.9-75.8 20.3l192.6 567.4c0 0-0.1 0-0.1 0l-265-537.3c-23.5 11.6-46.2 24.8-67.9 39.3l332.8 498.1c0 0-0.1 0-0.1 0.1L4.4-51.1C-15.3-33.9-33.8-15.3-51.1 4.4l450.4 395c0 0 0 0.1-0.1 0.1L-99 66.6c-14.5 21.7-27.6 44.4-39.3 68l537.4 265c0 0 0 0.1 0 0.1l-567.4-192.6c-8.3 24.6-15.1 49.9-20.2 75.8L399 399.8c0 0 0 0.1 0 0.1l-597.7-39.2c-1.7 26.5-1.7 52.7-0.1 78.5L399 400.1c0 0 0 0.1 0 0.1l-587.6 116.9c5.1 25.9 11.9 51.2 20.3 75.8l567.4-192.6c0 0 0 0.1 0 0.1l-537.3 265c11.6 23.5 24.8 46.2 39.3 67.9l498.1-332.8c0 0 0 0.1 0.1 0.1l-450.4 395c17.3 19.7 35.8 38.2 55.5 55.5l395-450.4c0 0 0.1 0 0.1 0.1L66.6 899c21.7 14.5 44.4 27.6 68 39.3l265-537.4c0 0 0.1 0 0.1 0L207.1 968.3c24.6 8.3 49.9 15.1 75.8 20.2L399.8 401c0 0 0.1 0 0.1 0l-39.2 597.7c26.5 1.7 52.7 1.7 78.5 0.1L400.1 401c0 0 0.1 0 0.1 0l116.9 587.6c25.9-5.1 51.2-11.9 75.8-20.3L400.3 400.9c0 0 0.1 0 0.1 0l265 537.3c23.5-11.6 46.2-24.8 67.9-39.3L400.5 400.8c0 0 0.1 0 0.1-0.1l395 450.4c19.7-17.3 38.2-35.8 55.5-55.5l-450.4-395c0 0 0-0.1 0.1-0.1L899 733.4c14.5-21.7 27.6-44.4 39.3-68l-537.4-265c0 0 0-0.1 0-0.1l567.4 192.6c8.3-24.6 15.1-49.9 20.2-75.8L401 400.2c0 0 0-0.1 0-0.1L998.7 439.2z'/%3E%3C/g%3E%3C/svg%3E"), linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 5%, rgba(255,255,255,0) 95%, rgba(255,255,255,1) 100%);
                //background-attachment: fixed;
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;
        `;
        public static QuizBackgroundMobileAlternative = styled.div`
                position: fixed;
                inset: 0;
                background-color: ${props => getColor(props, props.theme.colors.mainBackground)};
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 800'%3E%3Cdefs%3E%3CradialGradient id='a' cx='400' cy='400' r='50%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(255,255,255,0.9)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,1)'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='400' cy='400' r='70%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(204,204,204,0.4)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,0.4)'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='800'/%3E%3Cg fill-opacity='.8'%3E%3Cpath fill='url(%23b)' d='M998.7 439.2c1.7-26.5 1.7-52.7 0.1-78.5L401 399.9c0 0 0-0.1 0-0.1l587.6-116.9c-5.1-25.9-11.9-51.2-20.3-75.8L400.9 399.7c0 0 0-0.1 0-0.1l537.3-265c-11.6-23.5-24.8-46.2-39.3-67.9L400.8 399.5c0 0 0-0.1-0.1-0.1l450.4-395c-17.3-19.7-35.8-38.2-55.5-55.5l-395 450.4c0 0-0.1 0-0.1-0.1L733.4-99c-21.7-14.5-44.4-27.6-68-39.3l-265 537.4c0 0-0.1 0-0.1 0l192.6-567.4c-24.6-8.3-49.9-15.1-75.8-20.2L400.2 399c0 0-0.1 0-0.1 0l39.2-597.7c-26.5-1.7-52.7-1.7-78.5-0.1L399.9 399c0 0-0.1 0-0.1 0L282.9-188.6c-25.9 5.1-51.2 11.9-75.8 20.3l192.6 567.4c0 0-0.1 0-0.1 0l-265-537.3c-23.5 11.6-46.2 24.8-67.9 39.3l332.8 498.1c0 0-0.1 0-0.1 0.1L4.4-51.1C-15.3-33.9-33.8-15.3-51.1 4.4l450.4 395c0 0 0 0.1-0.1 0.1L-99 66.6c-14.5 21.7-27.6 44.4-39.3 68l537.4 265c0 0 0 0.1 0 0.1l-567.4-192.6c-8.3 24.6-15.1 49.9-20.2 75.8L399 399.8c0 0 0 0.1 0 0.1l-597.7-39.2c-1.7 26.5-1.7 52.7-0.1 78.5L399 400.1c0 0 0 0.1 0 0.1l-587.6 116.9c5.1 25.9 11.9 51.2 20.3 75.8l567.4-192.6c0 0 0 0.1 0 0.1l-537.3 265c11.6 23.5 24.8 46.2 39.3 67.9l498.1-332.8c0 0 0 0.1 0.1 0.1l-450.4 395c17.3 19.7 35.8 38.2 55.5 55.5l395-450.4c0 0 0.1 0 0.1 0.1L66.6 899c21.7 14.5 44.4 27.6 68 39.3l265-537.4c0 0 0.1 0 0.1 0L207.1 968.3c24.6 8.3 49.9 15.1 75.8 20.2L399.8 401c0 0 0.1 0 0.1 0l-39.2 597.7c26.5 1.7 52.7 1.7 78.5 0.1L400.1 401c0 0 0.1 0 0.1 0l116.9 587.6c25.9-5.1 51.2-11.9 75.8-20.3L400.3 400.9c0 0 0.1 0 0.1 0l265 537.3c23.5-11.6 46.2-24.8 67.9-39.3L400.5 400.8c0 0 0.1 0 0.1-0.1l395 450.4c19.7-17.3 38.2-35.8 55.5-55.5l-450.4-395c0 0 0-0.1 0.1-0.1L899 733.4c14.5-21.7 27.6-44.4 39.3-68l-537.4-265c0 0 0-0.1 0-0.1l567.4 192.6c8.3-24.6 15.1-49.9 20.2-75.8L401 400.2c0 0 0-0.1 0-0.1L998.7 439.2z'/%3E%3C/g%3E%3C/svg%3E"), linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 5%, rgba(255,255,255,0) 95%, rgba(255,255,255,1) 100%);
                //background-attachment: fixed;
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;
`;
        public static QuizBackgroundMobileGrid = styled.div`
                width: 100%;
                //height: 100%;
                display: grid;
                grid-template-rows: 50px calc(100vh - 140px) 50px;
                padding: 20px;
        `;

        public static FunctionsMobile = styled.div`
                width: 100%;
                height: 100%;
                max-height: 100%;
                overflow-y: auto;
                text-align: center;
                position: relative;
                overflow-x: hidden;
                padding-right: 5px;

        `;




        public static HeaderMobileAlternative = styled.div`
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 50px;
                text-align: left;
        `;
        public static FunctionsMobileAlternative = styled.div`
                position: fixed;
                top: 50px;
                left: 0;
                overflow-y: auto;
                overflow-x: hidden;
                width: 100%;
                height: calc(100vh - 120px);
                text-align: center;
                padding: 0 10px;

        `;
        public static FooterMobileAlternative = styled.div`
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 70px;
                text-align: center;
        `;





        public static FooterMobile = styled.div`
                width: 100%;
                height: 100%;
                text-align: center;
                position: relative;
        `;

        public static TitleMobile = styled.div`
                width: 100%;
                font-size: 1.1rem;
                font-weight: bolder;
                border-bottom: 1px solid ${props => getColor(props, props.theme.colors.middleLightGrey)};
                line-height: 40px;
                text-align: left;
        `;
        public static DescriptionMobile = styled.div`
                width: 100%;
                padding: 10px 0;
                font-size: 1rem;
                text-align: left;
    `;

        public static ImageMobile = styled.div`
                position: relative;
                display: block;
                width: 100%;
                height: 80px;
                margin-bottom: 40px;
        `;

        public static QuizTitleMobile = styled.div`
                width: calc(100 - 80px);
                line-height: 40px;
                font-size: 0.9rem;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;  
                font-weight: bolder;
`;
        public static QuizDescMobile = styled.div`
                width: 100%;
                font-size: 0.8rem;
                display: block;
                padding-left: 40px;
                padding-top: 10px;
`;
        public static MessageBox = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px;
    font-size: 1.2rem;
    background: white;
    box-shadow: 0 6px 8px -6px black;
    text-align: center;
    text-transform: uppercase;
    border: 1px solid ${p => getColor(p, "@accent")};
    z-index: 5000;
`;
        public static IWAOverlay = styled.div<{ imageWidth: number, imageHeight: number }>`
    //position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: relative;
    padding-bottom: ${p => p.imageHeight * 100 / p.imageWidth}%;
`;
        public static IWAImg = styled.img<{ isCorrect?: boolean }>`
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    filter: ${p => p.isCorrect ? "hue-rotate(90deg)" : "none"};
`;
        public static IWAArea = styled.div<{ opacity: number }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: ${p => p.opacity};
`;

        public static IMOOverlay = styled.div<{ imageWidth: number, imageHeight: number }>`
    //position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: relative;
    padding-bottom: ${p => p.imageHeight * 100 / p.imageWidth}%;
`;

        public static IMOCell = styled.div.attrs<{ left: number, top: number }>(p => ({
                style: { left: p.left, top: p.top }
        }))
                <{ left: number, height: number, width: number, top: number, gridOpacity?: number, markerColor: string, displayCorrect?: boolean }>`
    position: absolute;
    width: ${p => p.width}px;
    height: ${p => p.height}px;
    cursor: ${p => p.displayCorrect ? "default" : "pointer"}; 
    border: 1px solid rgba(255,255,255,${p => p.gridOpacity ?? 0.01}); 
    z-index: 5000;
    overflow: hidden;
    &:hover{
        background: ${p => p.displayCorrect ? "inherit" : fadeColor(p, p.markerColor, 20)}; 
        border: ${p => p.displayCorrect ? "inherit" : "1px solid " + fadeColor(p, p.markerColor, 20)}; 
    }
`;
        public static IMODashing = styled.div<{ correctAnswer?: boolean, markerColor: string }>`
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        overflow: hidden;

        &:nth-of-type(1) {
            width:  200%;
            border-top: 1px dashed ${p => p.correctAnswer ? getColor(p, p.theme.colors.accentGreen) : p.markerColor};
            animation: ${slideDashTop}  5s infinite linear;
            z-index: 10000;
        }
        &:nth-of-type(2){
            height:  200%;
            border-right: 1px dashed ${p => p.correctAnswer ? getColor(p, p.theme.colors.accentGreen) : p.markerColor};
            animation: ${slideDashRight} 5s infinite linear;
            z-index: 10000;
        }
       &:nth-of-type(3) {
            width:  200%;
            border-bottom: 1px dashed ${p => p.correctAnswer ? getColor(p, p.theme.colors.accentGreen) : p.markerColor};
            animation: ${slideDashBottom}  5s infinite linear;
            z-index: 10000;
        }
        &:nth-of-type(4) {
            height:  200%;
            border-left: 1px dashed ${p => p.correctAnswer ? getColor(p, p.theme.colors.accentGreen) : p.markerColor};
            animation: ${slideDashLeft} 5s infinite linear;
            z-index: 10000;
        }
        &.off {
            border:  ${p => p.correctAnswer ? "1px dashed " + getColor(p, p.theme.colors.accentGreen) : "none"};
        }
`;

        public static IMOImg = styled.img`
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
`;
        public static SVGcontainer = styled.svg<{ width: number, paddingRight: number }>`
    width: ${p => p.width}px;
    height: 20px;
    position: absolute;
    right: ${p => p.paddingRight}px;
    top: 50%;
    transform: translateY(-50%);
`;
        public static Svg = styled.svg`
`;
        public static Line = styled.line`
    stroke: ${p => getColor(p, p.theme.colors.middleLightGrey)};
`;
        public static Circle = styled.circle`    
    &.color1 {fill: ${p => getColor(p, p.theme.colors.accent)};}
    &.color2 {fill: ${p => getColor(p, p.theme.colors.middleLightGrey)};}
    &.color3 {fill: ${p => getColor(p, p.theme.colors.accentGreen)};}
    &.color4 {fill: ${p => getColor(p, p.theme.colors.accentRed)};}
    &.color5 {fill: ${p => getColor(p, p.theme.colors.mainForeground)};}
    &.color11 {fill: ${p => getColor(p, p.theme.colors.middleLightGrey)};}
    &.color21 {fill: ${p => getColor(p, p.theme.colors.mainBackground)};}
`;
        public static Rect = styled.rect`    
    &.color1 {fill: ${p => getColor(p, p.theme.colors.accent)};}
    &.color2 {fill: ${p => getColor(p, p.theme.colors.middleLightGrey)};}
    &.color21 {fill: ${p => getColor(p, p.theme.colors.mainBackground)};}
`;

        public static TISvg = styled.svg`    
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0px;
`;
        public static TICircle = styled.circle`    
    fill: none;
    stroke: ${p => getColor(p, p.theme.colors.veryLightGrey)};
    animation: ${pulse1} 0.6s 4 both;
`;
        public static TICircleInfiniteTime = styled.circle`    
    fill: none;
    stroke: ${p => getColor(p, p.theme.colors.middleLightGrey)};
`;
        public static ResultInfo = styled.div`    
        animation: ${pulse1} 0.6s 4 both;
        position: absolute;
        top: 9px;
        right: ${p => belowBreakpointOrEqual(p, "mobile") ? 6 : belowBreakpointOrEqual(p, "tablet") ? 10 : 13}px;
`;

        public static TIText = styled.text<{ light: boolean, fontSize: number }>`    
    z-index: 3;
    font-size: ${p => p.fontSize}px;
    font-weight: bold;
    fill: ${p => p.light ? getColor(p, p.theme.colors.veryLightGrey) : getColor(p, p.theme.colors.mainForeground)};
    animation: ${p => p.light ? pulse2 : "none"} 0.6s 4 both;
`;
        public static TITextInfiniteTime = styled.text<{ fontSize: number }>`    
    z-index: 3;
    font-size: ${p => belowBreakpointOrEqual(p, "tablet") ? 24 : 32}px;
    fill: ${p => getColor(p, p.theme.colors.middleLightGrey)};
    //transform: translate(0px, ${p => belowBreakpointOrEqual(p, "tablet") ? -3 : 8}px);
    
`;
        public static TIPath = styled.path<{ warning: boolean }>`    
    transform-origin: center center;
    &.inner {
        fill: none;
        stroke: ${p => p.warning ? getColor(p, p.theme.colors.middleLightGrey) : getColor(p, p.theme.colors.accent)};
        animation: ${p => p.warning ? pulse0 : "none"} 1s ease-in-out infinite both;
    }
    &.outer {
        fill: none;
        stroke: ${p => p.warning ? getColor(p, p.theme.colors.accent) : getColor(p, p.theme.colors.middleLightGrey)};
    }  
`;
}
